/* @flow */
/*jshint esversion: 6 */
import { Button, Icon } from "antd";
import React, { Component } from "react";
import "../../App.css";
import GenericModal from "../../components/GenericModal";
import LangContext from "../../contextProvider/LangContext";
import CarList from "../Customers/CarList";


class CarListForAutoIphone extends Component {
    state = {
        modalOpen: false
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }


    render() {
        return (<div style={{ textAlign: "center", marginBottom: 24, display: 'inline-block', verticalAlign: 'text-top' }}>
            <Button onClick={() => { this.setState({ modalOpen: true }) }}>
                <Icon type={"car"} style={{ marginLeft: 5 }} />
                {this.getText(17115)}
            </Button>
            {this.state.modalOpen ?
                (<GenericModal visible onCancel={() => { this.setState({ modalOpen: false }) }}>
                    <CarList {...this.props} />
                </GenericModal>)
                : ""}
        </div>)
    }
}

export default CarListForAutoIphone;